"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcRentalServiceCostAllocators = class UcRentalServiceCostAllocators extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    service;
    onService(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("service");
    }
    ux;
    dataMembers = ['ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ux: null,
            },
        };
    }
    async act_2576027262358435_emit_9562_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_2576027262358435_showModal_9560_getActionArgs($event) {
        return {
            name: "RentalServiceCostAllocator",
            props: {
                oid: $event.scope.item.id,
                service: this.service,
            },
        };
    }
    async evh_2576027262358435_clickPreventStop(event, scope) {
        return await this.actions.evh_2576027262358435_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_7593494570053535_emit_9566_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_7593494570053535_request_9564_getActionArgs($event) {
        return {
            operation: "delete_rental_service_cost_allocator",
            data: $event.scope.item,
        };
    }
    async act_7593494570053535_request_9564_getConfirm($event) {
        return {
            message: this.$fn.gettext("Please confirm delete."),
            btnOk: this.$fn.gettext("Delete"),
        };
    }
    async evh_7593494570053535_clickPreventStop(event, scope) {
        return await this.actions.evh_7593494570053535_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2140198529698299_showModal_9568_getActionArgs($event) {
        return {
            name: "RentalServiceCostAllocator",
            props: {
                service: this.service,
            },
        };
    }
    async evh_2140198529698299_clickPreventStop(event, scope) {
        return await this.actions.evh_2140198529698299_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_2576027262358435_emit_9562 = new core_1.actions.EmitAction({
            actionArgs: this.act_2576027262358435_emit_9562_getActionArgs,
            events: [],
        });
        const evh_2576027262358435_close_9561 = new core_1.actions.EventHandlerImpl({
            action: act_2576027262358435_emit_9562,
            event: "close",
            displayName: "emit",
        });
        const act_2576027262358435_showModal_9560 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2576027262358435_showModal_9560_getActionArgs,
            events: [evh_2576027262358435_close_9561],
        });
        const evh_2576027262358435_clickPreventStop_9559 = new core_1.actions.EventHandlerImpl({
            action: act_2576027262358435_showModal_9560,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_2576027262358435_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2576027262358435_clickPreventStop_9559],
        });
        const act_7593494570053535_emit_9566 = new core_1.actions.EmitAction({
            actionArgs: this.act_7593494570053535_emit_9566_getActionArgs,
            events: [],
        });
        const evh_7593494570053535_success_9565 = new core_1.actions.EventHandlerImpl({
            action: act_7593494570053535_emit_9566,
            event: "success",
            displayName: "emit",
        });
        const act_7593494570053535_request_9564 = new core_1.actions.RequestAction({
            actionArgs: this.act_7593494570053535_request_9564_getActionArgs,
            confirm: this.act_7593494570053535_request_9564_getConfirm,
            events: [evh_7593494570053535_success_9565],
        });
        const evh_7593494570053535_clickPreventStop_9563 = new core_1.actions.EventHandlerImpl({
            action: act_7593494570053535_request_9564,
            event: "click.prevent.stop",
            displayName: "request",
        });
        const evh_7593494570053535_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7593494570053535_clickPreventStop_9563],
        });
        const act_2140198529698299_showModal_9568 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2140198529698299_showModal_9568_getActionArgs,
            events: [],
        });
        const evh_2140198529698299_clickPreventStop_9567 = new core_1.actions.EventHandlerImpl({
            action: act_2140198529698299_showModal_9568,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_2140198529698299_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2140198529698299_clickPreventStop_9567],
        });
        return {
            act_2576027262358435_emit_9562,
            evh_2576027262358435_close_9561,
            act_2576027262358435_showModal_9560,
            evh_2576027262358435_clickPreventStop_9559,
            evh_2576027262358435_clickPreventStop,
            act_7593494570053535_emit_9566,
            evh_7593494570053535_success_9565,
            act_7593494570053535_request_9564,
            evh_7593494570053535_clickPreventStop_9563,
            evh_7593494570053535_clickPreventStop,
            act_2140198529698299_showModal_9568,
            evh_2140198529698299_clickPreventStop_9567,
            evh_2140198529698299_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcRentalServiceCostAllocators.prototype, "service", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('service'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRentalServiceCostAllocators.prototype, "onService", null);
UcRentalServiceCostAllocators = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcRentalServiceCostAllocators);
exports.default = UcRentalServiceCostAllocators;
vue_property_decorator_1.Vue.component("UcRentalServiceCostAllocators", UcRentalServiceCostAllocators);
